import React from "react";
import { Link } from "react-router-dom";
import { Card, Col, Row } from "react-bootstrap";

import eftergymnasialUtbildningImg from "assets/eftergymnasialutbildning.webp";
import gymnasiumImg from "assets/gymnasium.webp";
import studentJobbImg from "assets/studentjobb.webp";
import kompetensutvecklingImg from "assets/kompetensutveckling.webp";

import "./style.css";
import { ScrollToTop } from "components/ScrollToTop";
import PanoramaFirstPage from "components/PanoramaFirstPage";

export default function Home() {
    const sections = [
        {
            sectionName: "Gymnasium",
            sectionUrl: "gymnasium",
            sectionFigure: gymnasiumImg,
            sectionIcon: "https://res.cloudinary.com/hm7cvv3hp/image/upload/v1599592640/us/utbildningssidan-b.png",
            description: "Hitta och jämför gymnasiala utbildningar.",
        },
        {
            sectionName: "Eftergymnasial utbildning",
            sectionUrl: "eftergymnasial-utbildning",
            sectionFigure: eftergymnasialUtbildningImg,
            sectionIcon: "https://res.cloudinary.com/hm7cvv3hp/image/upload/v1599592640/us/utbildningssidan-b.png",
            description: "Hitta och jämför eftergymnasiala utbildningar.",
        },
        {
            sectionName: "Studentjobb",
            sectionUrl: "studentjobb",
            sectionFigure: studentJobbImg,
            sectionIcon: "https://res.cloudinary.com/hm7cvv3hp/image/upload/v1598874104/us/traineesearch-v.png",
            description: "Hitta och jämför: Traineeprogram Internships Examensarbeten Sommarjobb och Extrajobb",
        },
        {
            sectionName: "Kompetensutveckling",
            sectionUrl: "kompetensutveckling",
            sectionFigure: kompetensutvecklingImg,
            sectionIcon: "https://res.cloudinary.com/hm7cvv3hp/image/upload/v1598873921/us/utbildning24-logo.png",
            description: "Hitta rätt kompetensutveckling för din karriär",
        },
    ];

    return (
        <div className="Home">
            <ScrollToTop />
            <PanoramaFirstPage />
            <Header />

            <ul>
                {sections.map((section) => {
                    return <Item section={section} />;
                })}
            </ul>
        </div>
    );
}

function Header() {
    return (
        <header>
            <h1 className="sectionVal">Välj sektion!</h1>

            <img
                alt="TODO"
                loading="lazy"
                width="100px"
                height="100px"
                src="https://res.cloudinary.com/hm7cvv3hp/image/upload/v1616584034/us/flech-verte_imagelarge.png"
            />
        </header>
    );
}

function Item({ section }) {
    console.log("Item", section.sectionUrl);
    return (
        <Link to={section.sectionUrl}>
            <Card className="Item card-shadow-home grow hoverable">
                <Card.Title className="pt-5">
                    <img src={section.sectionIcon} alt="TODO" loading="lazy" width="20px" height="20px" />
                    {section.sectionName}
                </Card.Title>
                <Card.Body>
                    <Row>
                        <Col xs={4}>
                            <img src={section.sectionFigure} className="figure" alt="TODO" loading="lazy" />
                        </Col>
                        <Col xs={8}>
                            <Card.Text>{section.description}</Card.Text>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Link>
    );
}
